import React, { useState, useRef, useEffect } from "react";
import { string, func, shape, bool } from "prop-types";

import Icon from "../../../Icon/Icon.jsx";

const propTypes = {
  keywords: string,
  handleEntry: func.isRequired,
  loading: bool,
  dictionary: shape({
    searchBoxPlaceholder: string,
    searchBoxLabel: string,
  }).isRequired,
};

const KeywordSearch = props => {
  const [initiatedLoad, setInitiatedLoad] = useState(false),
    keywordInput = useRef(null),
    { handleEntry, dictionary, keywords, loading } = props;

  useEffect(() => {
    if (!loading) {
      setInitiatedLoad(false);
    }
  }, [loading]);

  useEffect(() => {
    keywordInput.current.value = keywords || "";
  }, [keywords]);

  const handleSubmit = event => {
    event.preventDefault();
    handleEntry(keywordInput.current.value);
    setInitiatedLoad(true);
  };

  const handleClear = event => {
    if (keywordInput.current.value === "") {
      handleEntry(keywordInput.current.value);
      setInitiatedLoad(true);
    }
  };

  return (
    <form
      className="keyword-search"
      onSubmit={handleSubmit}
      noValidate
      role="search"
    >
      <div className="keyword-search__input">
        <label htmlFor="site-search" className="u-visuallyhidden">
          {dictionary.searchBoxLabel}
        </label>
        {/* 
        No longer needed, but saving just in case it comes back
        <select>
          <option>All of these words</option>
          <option>Exact Phrase</option>
        </select> */}
        <input
          id="site-search"
          type="search"
          placeholder={dictionary.searchBoxPlaceholder}
          defaultValue={keywords || ""}
          ref={keywordInput}
          onChange={handleClear}
        />
        <button type="submit" className="btn btn--primary">
          Search <i className="fal fa-long-arrow-right"></i>
        </button>
      </div>
    </form>
  );
};

KeywordSearch.propTypes = propTypes;
export default KeywordSearch;
